import React from 'react';
import { customerServiceNumberFormatted } from '../../../utility/utils/formatter';
import { formatDateMDYYYY } from '../../../utility/utils/dateUtil';
import Onetime from './oneTime';

const Locked = (props) => {
    const {paymentsCss} = props;

    const serviceAgreement = props.serviceAgreement;
    const {lock , lstBadSvc , oops , scvLocked , number , forAssist } = props.labels;
    const { labels, invoiceAmountDue, isActionEnabled } = props;

    return (
      <>
        <div className={`row ${paymentsCss["mb-16"]} ${paymentsCss["tru-mma-main-content-box"]}`}>
          <div className={`col-12 col-md-8 col-lg-9 ${paymentsCss["gfw-3"]} ${paymentsCss["p-30"]} text-center ${paymentsCss["text-md-left"]} ${paymentsCss["tru-mma-main-content"]}`}>
            <div className='mb-10'>
              <object type='image/svg+xml' data={'/images/MyAccount/Icons/lock.svg'} className='mr-5' height='25'>
                {lock}
              </object>
              <span className={`${paymentsCss["gfs-24"]} ${paymentsCss["gfs-lg-30"]} glh-1 ${paymentsCss["text-danger"]}`}>{serviceAgreement.svcLineDesc}</span>
            </div>
            <span className={`d-block ${paymentsCss["gfs-lg-20"]} ${paymentsCss["mb-5"]} ${paymentsCss["text-gray-dark"]}`}>
              {`${serviceAgreement.LatestServiceDate ? lstBadSvc + ' ' + formatDateMDYYYY(serviceAgreement.woMostRecentComplDate) : ' '}`}
            </span>
            <div className="row">
              <div className={`col-1 ${paymentsCss["pt-5"]}`}>
                <img src='/images/MyAccount/Icons/error-notification-icon.png' className='' alt='Temporarily Locked' width='25' />  
              </div>
              <div className="col-11 pl-5">
                <span className={`${paymentsCss["gfs-14"]} gfw-14`}>
                  {labels.lockedServiceAmountDue} <a href={labels.contactLink} className={`${paymentsCss["text-green"]} ${paymentsCss["js-phoneno"]}`}>{customerServiceNumberFormatted}</a>
                </span>
              </div>
            </div>
          </div>
          <Onetime isActionEnabled={isActionEnabled} arBalance={invoiceAmountDue} labels={labels} paymentsCss={paymentsCss} />
        </div>
      </>
    );
}

export default Locked;
